export default function SolarIcon() {
    return (
        <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 17.4594C14.0873 17.4594 17.4007 14.1419 17.4007 10.0494C17.4007 5.95698 14.0873 2.6394 10 2.6394C5.91272 2.6394 2.59932 5.95698 2.59932 10.0494C2.59932 14.1419 5.91272 17.4594 10 17.4594Z"
                fill="#FFC808"
            />
            <path
                d="M10 11.7325C10.9284 11.7325 11.681 10.979 11.681 10.0494C11.681 9.11984 10.9284 8.36627 10 8.36627C9.07161 8.36627 8.31901 9.11984 8.31901 10.0494C8.31901 10.979 9.07161 11.7325 10 11.7325Z"
                fill="black"
            />
            <path
                d="M10.0035 4.30136H10C9.75282 4.30136 9.55245 4.502 9.55245 4.74949V7.44533C9.55245 7.69282 9.75282 7.89346 10 7.89346H10.0035C10.2507 7.89346 10.4511 7.69282 10.4511 7.44533V4.74949C10.4511 4.502 10.2507 4.30136 10.0035 4.30136Z"
                fill="black"
            />
            <path
                d="M10.0035 12.2054H10C9.75282 12.2054 9.55245 12.406 9.55245 12.6535V15.3493C9.55245 15.5968 9.75282 15.7975 10 15.7975H10.0035C10.2507 15.7975 10.4511 15.5968 10.4511 15.3493V12.6535C10.4511 12.406 10.2507 12.2054 10.0035 12.2054Z"
                fill="black"
            />
            <path
                d="M15.7444 10.0529V10.0494C15.7444 9.80191 15.544 9.60129 15.2968 9.60129H12.6044C12.3572 9.60129 12.1568 9.80191 12.1568 10.0494V10.0529C12.1568 10.3004 12.3572 10.5011 12.6044 10.5011H15.2968C15.544 10.5011 15.7444 10.3004 15.7444 10.0529Z"
                fill="black"
            />
            <path
                d="M7.8503 10.0529V10.0494C7.8503 9.80193 7.64991 9.60129 7.40273 9.60129H4.71029C4.46311 9.60129 4.26273 9.80193 4.26273 10.0494V10.0529C4.26273 10.3004 4.46311 10.5011 4.71029 10.5011H7.40273C7.64991 10.5011 7.8503 10.3004 7.8503 10.0529Z"
                fill="black"
            />
            <path
                d="M14.0568 14.1178L14.0593 14.1153C14.234 13.9403 14.234 13.6566 14.0593 13.4816L12.1554 11.5753C11.9806 11.4003 11.6972 11.4003 11.5225 11.5753L11.52 11.5778C11.3452 11.7528 11.3452 12.0366 11.52 12.2116L13.4238 14.1178C13.5986 14.2928 13.882 14.2928 14.0568 14.1178Z"
                fill="black"
            />
            <path
                d="M8.47846 8.52858L8.48095 8.52608C8.65574 8.35107 8.65574 8.06733 8.48096 7.89232L6.57712 5.98608C6.40233 5.81107 6.11894 5.81108 5.94416 5.98608L5.94166 5.98858C5.76688 6.16359 5.76687 6.44733 5.94166 6.62234L7.8455 8.52858C8.02028 8.70359 8.30367 8.70358 8.47846 8.52858Z"
                fill="black"
            />
            <path
                d="M14.0635 5.98735L14.061 5.98485C13.8862 5.80984 13.6029 5.80984 13.4281 5.98484L11.5242 7.89109C11.3494 8.06609 11.3494 8.34984 11.5242 8.52484L11.5267 8.52734C11.7015 8.70235 11.9849 8.70234 12.1597 8.52733L14.0635 6.62109C14.2383 6.44608 14.2383 6.16235 14.0635 5.98735Z"
                fill="black"
            />
            <path
                d="M8.48088 11.5766L8.47838 11.5741C8.3036 11.3991 8.02021 11.3991 7.84543 11.5741L5.94159 13.4804C5.7668 13.6554 5.76681 13.9391 5.94159 14.1141L5.94409 14.1166C6.11887 14.2916 6.40226 14.2916 6.57704 14.1166L8.48088 12.2104C8.65567 12.0354 8.65566 11.7516 8.48088 11.5766Z"
                fill="black"
            />
        </svg>
    );
}
